import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { AUTH } from './cookieKeys';
import { IAppState } from '../redux/IAppState';
import {useEffect} from 'react';

/**
 * AppStateToCookieMapper: a component that renders nothing, but subscribes to relevant App State and updates app
 * cookie state to match. Currently only used for the bearer token to track login across refreshes and forced
 * user password resets.
 *
 * Keep this payload minimal. It rides along on every request, and the browser 400s at the reverse proxy once the
 * Cookie header outgrows the proxy's header buffer. resortToolsConfig used to live here; useAuthBootstrap
 * refetches it through getConfigAction on resort selection, so a refresh rebuilds it.
 *
 * Connected to Redux: false
 * Renders: false
 */

const AppStateToCookieMapper = () => {
  const auth = useSelector((state: IAppState) => state.auth);
  const userState = useSelector((state: IAppState) => state.userState);

  useEffect(() => {

    if (userState) {
      const payload = JSON.stringify({
        username:       auth.username || '',
        userRole:       userState.role || '',
        bearerToken:    auth.bearerToken || '',
        bearerTokenExp: auth.bearerTokenExp,
        isLoggedIn:    auth.isLoggedIn,
      });

      // Browsers silently drop a cookie past ~4096 bytes, and every cookie shares the one
      // Cookie header nginx buffers. Warn before either limit bites.
      if (payload.length > 3500) {
        console.warn(`AUTH cookie payload is ${payload.length} bytes — nearing the 4096-byte browser cookie limit`);
      }

      Cookies.set(
        AUTH,
        payload,
        {
          secure: true
        }
      );
    }

  }, [auth, userState]);

  return null; // Ain't no rendering here.
};

export default AppStateToCookieMapper;
